import cx from 'classnames';
import React, { useContext } from 'react';
import { RelayLogicTimeZones } from '../../../../../../../../model/DeviceAdminModel';
import { Select } from '../../../../../../../common';
import { DoorStoreSingleContext } from '../../../../../DoorModal/DoorStoreSingleContext';
import { setDisableTimeZone, StoreContext } from '../../../../contextExpansionRelay';
import styles from '../../../../expansionRelayModal.module.scss';

type Props = {
	setPreviousSelections: (RelayLogicTimeZones) => void;
	previousSelections: RelayLogicTimeZones;
	useDoorContext: boolean;
};

const Disable: React.FC<Props> = props => {
	const { setPreviousSelections, previousSelections, useDoorContext } = props;
	if (useDoorContext) {
		var {
			contextStateDoor: {
				relay: { disableTimeZones, selections, unpermitted },
			},
			dispatcherDoor,
		} = useContext(DoorStoreSingleContext);
	} else {
		var {
			expansionRelayState: { disableTimeZones, selections, unpermitted },
			dispatcher,
		} = useContext(StoreContext);
	}

	const options = unpermitted.disableTimeZone
		? [
				{
					label: unpermitted.disableTimeZone.Name,
					value: unpermitted.disableTimeZone.GenericId.toString(),
					id: `relayLogicDisableTimeZoneOption-${unpermitted.disableTimeZone.GenericId.toString()}`,
				},
		  ]
		: disableTimeZones.map(x => ({ label: x.Name, value: x.GenericId.toString(), id: `relayLogicDisableTimeZoneOption-${x.GenericId.toString()}` }));

	return (
		<div className={styles.sections}>
			<span>{_('DisableTimezone')}</span>
			<div>
				<Select
					id='relayLogicDisableTimeZoneDropdown'
					className={cx(styles.select)}
					options={options}
					onChange={value => {
						if (Number(value) !== 0) {
							setPreviousSelections({ ...previousSelections, Disable: Number(value) });
						}

						useDoorContext ? dispatcherDoor(setDisableTimeZone(Number(value))) : dispatcher(setDisableTimeZone(Number(value)));
					}}
					key='disableTimeZone'
					value={selections.disableTimeZone.toString()}
					disabled={unpermitted.disableTimeZone ? true : false}
					getPopupContainer={() => document.getElementById('logicRelayContainer')}
				/>
			</div>
		</div>
	);
};

export { Disable };
